import { useState, useContext, useEffect } from 'react';

import classes from './QNumber.module.scss';

import TriviaContext from '../../store/trivia-context';

function QNumber(props) {
    const triviaCtx = useContext(TriviaContext);
    const [styleClass, setStyleClass] = useState();

    useEffect(() => {
        let questionStatus = triviaCtx.triviaStatus.find(x => x.qno === +props.qno);

        if (questionStatus) {
            if (questionStatus.current) {
                setStyleClass(classes["qno-current"]);
            } else if (questionStatus.result) {
                setStyleClass(classes["qno-right"]);
            } else if (questionStatus.result === false) {
                setStyleClass(classes["qno-wrong"]);
            } else {
                setStyleClass(null);
            }
        } else {
            setStyleClass(null);
        }
    }, [triviaCtx.triviaStatus, triviaCtx.currentQuestionNo, props.qno]);

    // status="qno-right"
    // status="qno-wrong"
    // status="qno-current"
    // console.log(props.qno);
    // console.log(triviaCtx.triviaStatus);
    // console.log(styleClass);

    return (
        <div className={`${classes["q-number"]} ${styleClass}`}>
            {+props.qno + 1}
        </div>
    )
}

export default QNumber
